import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProviderClasses, StateStatus } from '@guryou/redux';

const useClass = ({ serviceId, classId }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.classes.all);

  useEffect(() => {
    if (
      (classId && serviceId && status === StateStatus.NOT_INITIALIZED) ||
      (classId && serviceId && status === StateStatus.LOADED && request?.serviceId !== serviceId)
    ) {
      dispatch(getProviderClasses(serviceId));
    }
  }, [classId, dispatch, request, serviceId, status]);

  if (!classId) {
    return { gyClass: null };
  }

  return { gyClass: (data || []).find(x => x.id === classId), status, version, entity };
};

export default useClass;
